<mat-selection-list
  disableRipple="true"
  class="listFactTemp"
  [formControl]="control"
>
  <h3 matSubheader class="last-header">Factuality</h3>
  <mat-list-option
    *ngFor="let factuality of factTemp.factuality"
    [value]="factuality.value"
    (click)="$event.stopPropagation(); toggleOption.emit(factuality)"
    class="pendo-factuality-option"
  >
    <div class="filter-text">
      <span>{{ factuality.label }}</span>
    </div>
  </mat-list-option>
  <div class="inner-subheader"></div>
  <h3 matSubheader class="last-header">Temporality</h3>
  <mat-list-option
    *ngFor="let temporality of factTemp.temporality"
    [value]="temporality.value"
    (click)="$event.stopPropagation(); toggleOption.emit(temporality)"
    class="pendo-temporality-option"
  >
    <div class="filter-text">
      <span>{{ temporality.label }}</span>
    </div>
  </mat-list-option>
</mat-selection-list>
